import React from 'react';
import { Redirect } from 'react-router-dom';
import buildPATHS from '../utils/paths';

const PageNotFound: React.FC = () => {
  const PATHS = buildPATHS();

  return <Redirect to={PATHS.login} />;
};

export default PageNotFound;
